import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { numberFormat } from '@fiverr-private/localization';
import InvitePopUp from '../InvitePopUp';
import AddYourNamePopUp from '../AddYourNamePopUp';
import LeaveWithoutInvite from '../LeaveWithoutInvite';
import { sendMixPanelEvent } from '../../../Utils/mixpanel';
import { OPEN_FULLNAME_MODAL, SUBMIT_FULLNAME, DISMISS_FULLNAME, INVITE } from '../../../Utils/mixpanel/mixpanelEvents';
import reportToBigQuery from '../../../Utils/bigQueryReporter';
import { showErrorToast, showSuccessToast } from '../ButterToasts';
import * as Error from '../../utils/error';
import * as CollaboratorsActions from '../../actions/collaborators';
import * as CollaboratorsSelectors from '../../selectors/collaborators';
import * as CurrentsSelectors from '../../selectors/current';
import * as Translations from '../../providers/i18n';

class InvitePopUpManager extends Component{
    constructor(props) {
        super(props);

        this.state = {
            emails: [],
            shouldShowAddYourName: false,
            shouldShowLeaveWithoutInvite: false,
            payload: {}
        };

        this.onShareClick = this.onShareClick.bind(this);
        this.onUpdateClick = this.onUpdateClick.bind(this);
        this.onStayClick = this.onStayClick.bind(this);
        this.onLeaveClick = this.onLeaveClick.bind(this);
        this.onExitWithoutFullName = this.onExitWithoutFullName.bind(this);
        this.sendInviteMixPanelEvent = this.sendInviteMixPanelEvent.bind(this);
    }

    sendInviteMixPanelEvent({ content }) {
        const { emails } = this.state;

        sendMixPanelEvent({
            eventName: INVITE,
            eventData: {
                'Has Personal Message':!!content,
                'Send Me A Copy': false,
                'Number Of Invitees': emails.length
            }
        });
    }

    onShareClick(payload) {
        const {
            emails
        } = this.state;

        const {
            currentCollaboratorFullName,
            inviteCollaboratorsToCollaboratorsGroup,
            i18n
        } = this.props;

        if (currentCollaboratorFullName) {
            inviteCollaboratorsToCollaboratorsGroup({
                filerrIds: payload.filerrIds,
                personalMessage: payload.content,
                inviterFullName: currentCollaboratorFullName,
                emails
            }).then(() => {
                this.sendInviteMixPanelEvent({
                    content: payload.content
                });
                const formattedCollaboratorsCount = numberFormat(emails.length, {
                    fallbackValue: emails.length
                });
                showSuccessToast(i18n.t('attachments_preview.collaboration.toasts.invite_collaborators', { count: formattedCollaboratorsCount }));
            }
            ).catch((error) => {
                Error.send(error, 'InvitePopUpManagerComponents#onShareClick');
                showErrorToast(i18n.t('attachments_preview.collaboration.toasts.error'));
            });

            return;
        }

        payload.emails = emails;

        this.setState({
            shouldShowAddYourName: true,
            payload
        });

        sendMixPanelEvent({
            eventName: OPEN_FULLNAME_MODAL
        });

        reportToBigQuery({
            group: 'collaboration',
            type: 'seen_update_personal_details_collaboration_popup',
            collaboration: {
                group: {
                    id: payload.groupId,
                    type: 'collaborators'
                }
            }
        });
    }

    onUpdateClick(firstName, lastName) {
        const fullName = `${firstName} ${lastName}`;

        const {
            payload
        } = this.state;

        const {
            filerrIds,
            content,
            emails,
            groupId
        } = payload;

        const {
            currentCollaboratorId,
            inviteCollaboratorsToCollaboratorsGroup,
            updateCollaborator,
            i18n
        } = this.props;

        Promise.resolve().then(() =>
            updateCollaborator({
                id: currentCollaboratorId,
                fullName
            })
        ).then(() =>
            inviteCollaboratorsToCollaboratorsGroup({
                filerrIds,
                personalMessage: content,
                inviterFullName: fullName,
                emails
            })
        ).then(() => {
            const formattedCollaboratorsCount = numberFormat(emails.length, {
                fallbackValue: emails.length
            });
            return showSuccessToast(i18n.t('attachments_preview.collaboration.toasts.invite_collaborators', { count: formattedCollaboratorsCount }));
        }).catch((error) => {
            Error.send(error, 'InvitePopUpManagerComponents');
            showErrorToast(i18n.t('attachments_preview.collaboration.toasts.error'));
        });

        this.sendInviteMixPanelEvent({
            content
        });

        this.setState({
            shouldShowAddYourName: false
        });

        sendMixPanelEvent({
            eventName: SUBMIT_FULLNAME
        });

        reportToBigQuery({
            group: 'collaboration',
            type: 'collaboration_done_update_personal_details',
            collaboration: {
                group: {
                    id: groupId,
                    type: 'collaborators'
                }
            }
        });
    }

    onExitWithoutFullName() {
        this.setState({
            shouldShowAddYourName: false,
            shouldShowLeaveWithoutInvite: true
        });

        sendMixPanelEvent({
            eventName: DISMISS_FULLNAME
        });

        reportToBigQuery({
            group: 'collaboration',
            type: 'collaboration_close_update_personal_details',
            collaboration: {
                group: {
                    id: this.state.payload.groupId,
                    type: 'collaborators'
                }
            }
        });
    }

    onStayClick() {
        this.setState({
            shouldShowAddYourName: true,
            shouldShowLeaveWithoutInvite: false
        });
    }

    onLeaveClick() {
        this.setState({
            shouldShowAddYourName: false,
            shouldShowLeaveWithoutInvite: false
        });
    }

    onChange = (emails) => {
        this.setState({
            emails
        });
    }

    deleteAllEmails = () => {
        this.setState({
            emails: []
        });
    }

    render() {
        const {
            emails,
            shouldShowAddYourName,
            shouldShowLeaveWithoutInvite
        } = this.state;

        const {
            onlyCurrentFile,
            fileId,
            trigger,
            withoutDefaultTriggerMobileWevBehavior
        } = this.props;

        return (
            <div>
                <InvitePopUp emails={emails}
                    onChange={this.onChange}
                    fileIds={onlyCurrentFile ? [fileId] : []}
                    deleteAllEmails={this.deleteAllEmails}
                    onShareClick={this.onShareClick}
                    trigger={trigger}
                    withoutDefaultTriggerMobileWevBehavior={withoutDefaultTriggerMobileWevBehavior}/>
                {shouldShowAddYourName && <AddYourNamePopUp onUpdateClick={this.onUpdateClick} onExitWithoutFullName={this.onExitWithoutFullName}/>}
                {shouldShowLeaveWithoutInvite && <LeaveWithoutInvite onStayClick={this.onStayClick} onLeaveClick={this.onLeaveClick}/>}
            </div>
        );
    }
}

InvitePopUpManager.propTypes = {
    currentCollaboratorId: PropTypes.string,
    currentCollaboratorFullName: PropTypes.string,
    updateCollaborator: PropTypes.func,
    onlyCurrentFile: PropTypes.bool,
    fileId: PropTypes.string,
    inviteCollaboratorsToCollaboratorsGroup: PropTypes.func,
    trigger: PropTypes.any,
    withoutDefaultTriggerMobileWevBehavior: PropTypes.bool,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

const mapStateToProps = (state) => ({
    currentCollaboratorId: CurrentsSelectors.getCurrentCollaboratorId(state),
    currentCollaboratorFullName: CollaboratorsSelectors.getCurrentCollaboratorFullName(state),
    fileId: CurrentsSelectors.getCurrentFileId(state)
});

export default compose(
    Translations.connect,
    connect(mapStateToProps, {
        inviteCollaboratorsToCollaboratorsGroup: CollaboratorsActions.inviteCollaboratorsToCollaboratorsGroup,
        updateCollaborator: CollaboratorsActions.updateCollaborator
    }))(InvitePopUpManager);
